export const FETCH_GENERAL_NOTIFICATIONS = 'FETCH_GENERAL_NOTIFICATIONS';
export const SET_GENERAL_NOTIFICATIONS = 'SET_GENERAL_NOTIFICATIONS';
